<template>
  <div>
    <b-card title="Genel Bilgiler">
      <b-row>
        <b-col
          cols="12"
          md="3"
        >
          <b-list-group>
            <list-item
              title="Modül"
              :value="dataItem.component"
            />
          </b-list-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-list-group>
            <list-item
              title="Gerçekleştiren"
              :value="dataItem.username"
            />
          </b-list-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-list-group>
            <b-list-group-item>
              <div class="font-weight-bold text-primary">
                İşlem
              </div>
              <div class="font-weight-light">
                <b-badge
                  v-if="dataItem.action === 'modified'"
                  variant="light-warning"
                >
                  <feather-icon icon="EditIcon" />
                  Düzenleme
                </b-badge>
                <b-badge
                  v-if="dataItem.action === 'deleted'"
                  variant="light-danger"
                >
                  <feather-icon icon="TrashIcon" />
                  Silme
                </b-badge>
                <b-badge
                  v-if="dataItem.action === 'created'"
                  variant="light-primary"
                >
                  <feather-icon icon="PlusIcon" />
                  Oluşturma
                </b-badge>
              </div>
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-list-group>
            <list-item
              title="Tarih"
              :value="moment(dataItem.created).format('DD.MM.YYYY HH:mm:ss')"
            />
          </b-list-group>
        </b-col>
        <b-col
          cols="12"
          md="12"
          class="mt-1"
        >
          <b-list-group>
            <list-item
              title="Ip Adresi"
              :value="dataItem.ip_address"
            />
          </b-list-group>
        </b-col>
      </b-row>
    </b-card>
    <b-card title="Aktivite İçeriği">
      <b-row>
        <template v-for="(item,key) in dataItem.data">
          <b-col
            v-if="item"
            :key="key"
            cols="12"
            md="4"
            class="mb-1"
          >
            <template v-if="key == 'modified'">
              <b-list-group-item>
                <div class="font-weight-bold text-primary">
                  {{ key }}
                </div>
                <div class="font-weight-light">
                  {{ moment(item).format('DD.MM.YYYY HH:mm:ss') }}
                </div>
              </b-list-group-item>
            </template>
            <template v-else-if="key == 'created'">
              <b-list-group-item>
                <div class="font-weight-bold text-primary">
                  {{ key }}
                </div>
                <div class="font-weight-light">
                  {{ moment(item).format('DD.MM.YYYY HH:mm:ss') }}
                </div>
              </b-list-group-item>
            </template>
            <template v-else-if="key == 'deleted'">
              <b-list-group-item>
                <div class="font-weight-bold text-primary">
                  {{ key }}
                </div>
                <div class="font-weight-light">
                  {{ moment(item).format('DD.MM.YYYY HH:mm:ss') }}
                </div>
              </b-list-group-item>
            </template>
            <b-list-group v-else>
              <list-item
                :title="key"
                :value="item"
              />
            </b-list-group>
          </b-col>
        </template>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BListGroup, BRow, BCol, BListGroupItem, BBadge,
} from 'bootstrap-vue'
import ListItem from '@/views/Customers/View/ListItem.vue'

export default {
  name: 'EditPage',
  components: {
    BBadge,
    BListGroupItem,
    BListGroup,
    ListItem,
    BCard,
    BRow,
    BCol,
  },
  computed: {
    dataItem() {
      return this.$store.getters['eventLogs/dataItem']
    },
  },
  beforeCreate() {
    this.$store.commit('eventLogs/RESET_DATA_ITEM')
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      return this.$store.dispatch('eventLogs/getDataItem', this.$route.params.id)
    },
  },
}
</script>
